import { render, staticRenderFns } from "./FlywireButton.vue?vue&type=template&id=2b2941c0"
import script from "./FlywireButton.vue?vue&type=script&lang=js"
export * from "./FlywireButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports